import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { unitsService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as unitsActions from './actions';

export function getUnits(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_UNITS),
    mergeMap(({ payload }) => {
      return unitsService.getUnits(payload).pipe(
        map((res) => unitsActions.getUnitsSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
